import React, { useMemo } from 'react';
import {Button, Card, Col, Row} from 'react-bootstrap';

import IndexCard from '../Partials/IndexCard';
import {PlusLg} from "react-bootstrap-icons";
import moment from "moment";

const default_labelsCfg = {
  placeholder: 'Измеримые критерии, которые должны быть удовлетворены, для того чтобы проект мог считаться успешным. Показатели могут быть как количественные (например, «Количество вновь созданных совместных программ с ведущими вузами, реализация которых началась в текущем году») так и качественные (например, «Проведен анализ ключевых территорий и представлены рекомендации по продвижению»).',
};

export default function Indicators({
  data, periods, onChange, labelsCfg, isPortfolio, isPortfolioProject, fixedPcs, portfolioPcsData, disabled
}) {
  const labels = useMemo(() => ({ ...default_labelsCfg, ...(labelsCfg || {}) }), [labelsCfg]);
4
  const addPcsForPassport = () => {
    let equivalent = [], nonEquivalent = [];
    fixedPcs?.forEach((item) => {
      if (isPortfolioProject) {
        const parentPc = portfolioPcsData.find((pc) => pc.fixedPcId === item.id);
        return parentPc
          ? equivalent.push({
            ...item,
            isTermOver: !!item?.endDate && moment(item.endDate).add(1, 'd') < moment(moment()),
            isActiveForProj: (!parentPc.startDate || new Date(parentPc.startDate) <= new Date(data.endDate)) && (!parentPc.endDate || new Date(parentPc.endDate) >= new Date(data.startDate)),
            parentPcId: parentPc.id,
            parentPcOriginId: parentPc.pcOriginId,
          })
          : false;
      }
      const isProjTypeIncluded = item?.projTypes.map((x) => x?.id).includes(parseInt(data?.typeId));
      return (!!item?.endDate && moment(item.endDate).add(1, 'd') < moment(moment()))
        ? false
        : data?.typeId
          ? isProjTypeIncluded
            ? equivalent.push(item)
            : nonEquivalent.push(item)
          : false;
    });
    return [equivalent, nonEquivalent];
  };

  const [equivalentTypePcs, nonEquivalentTypePcs] = useMemo(() => addPcsForPassport(), [data?.typeId, portfolioPcsData, data?.startDate, data?.endDate]);
  return (
      <React.Fragment>
          {<Card className="mb-4">
              <Card.Header as={Card.Title} className="p-4">Унифицированные показатели</Card.Header>
              <Card.Body className="p-4">
                  <IndexCard
                      data={{ data: data.pcs, type: 'fixedPcs' }}
                      fixedPcs={[...equivalentTypePcs,...nonEquivalentTypePcs]}
                      periods={periods}
                      onChange={(pcs) => onChange(pcs, 'pcs')}
                      placeholder={labels.placeholder}
                      isPortfolioProject={isPortfolioProject}
                      projTypeId={parseInt(data?.typeId)}
                      disabled={disabled}
                  >
                  </IndexCard>

              </Card.Body>
          </Card>}
          {(!isPortfolio && !isPortfolioProject) && <Card className="mb-4">
          <Card.Header as={Card.Title} className="p-4">Неунифицированные показатели</Card.Header>
          <Card.Body className="p-4">
            <IndexCard
              data={{data:data.pcs, type: 'pcs', projectStatus: data.status}}
              periods={periods}
              onChange={(pcs) => onChange(pcs, 'pcs')}
              placeholder={labels.placeholder}
              disabled={disabled}
              // isPortfolioProject={isPortfolioProject}
              // projTypeId={data.typeId}
            />

          </Card.Body>
        </Card>}
      </React.Fragment>
  );
}

const cardHeaderStyling = {
  display: 'flex', justifyContent: 'end',
};
